var React = require('react');

function Occupants (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st0","d":"M16,16.3V20v1v1H0v-1v-1v-3.7C0,13.4,2.7,11,6,11h4C13.3,11,16,13.4,16,16.3z M8,10c2.8,0,5-2.2,5-5s-2.2-5-5-5S3,2.2,3,5S5.2,10,8,10z"}));
}

Occupants.defaultProps = {"width":"24","height":"24","viewBox":"0 0 16 22"};

module.exports = Occupants;

Occupants.default = Occupants;
